export enum DemoType {
  Shared = "shared",
  Preview = "preview"
}
